/* UKB4C compact header: hide on scroll-down, return on scroll-up; the
   saved-vehicle banner docks into the gap. Pure additive layer - no theme JS
   or cart/search bindings are touched. */
(function() {
  var css = [
    'header.site-header{transition:transform .28s ease}',
    '#ukb4c-veh-banner{transition:box-shadow .28s ease}',
    'html.ukb4c-compact [id*="__announcement-bar"]{display:none!important}',
    'html.ukb4c-compact header.site-header{transform:translateY(-115%)}',
    'html.ukb4c-compact #ukb4c-veh-banner{position:fixed;top:0;left:0;right:0;z-index:950;box-shadow:0 3px 14px rgba(0,0,0,.3)}'
  ].join('');
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);
  var lastY = window.scrollY || 0;
  var ticking = false;
  function onScroll() {
    var y = window.scrollY || 0;
    var goingDown = y > lastY + 4;
    var goingUp = y < lastY - 4;
    if (y > 260 && goingDown) document.documentElement.classList.add('ukb4c-compact');
    else if (goingUp || y < 140) document.documentElement.classList.remove('ukb4c-compact');
    lastY = y;
    ticking = false;
  }
  window.addEventListener('scroll', function() {
    if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
  }, { passive: true });
})();
